/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyConfig } from '../models/BackupPolicyConfig';
import { Pagination } from '../models/Pagination';

export class ListBackupPolicyResponse {
  'backupPolicies': Array<BackupPolicyConfig>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupPolicies",
      "baseName": "backupPolicies",
      "type": "Array<BackupPolicyConfig>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListBackupPolicyResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

